import { ColumnsType } from 'antd/es/table';
import * as React from 'react';
import { useTranslation } from 'react-i18next';

import {
  DictionarySettingsStore,
  DictionarySettingsValueModel,
} from 'stores/models/fieldsSettings';

import {
  ByDefaultRadioButton,
  DeleteRowButton,
  Label,
  OrderSelect,
} from './columns';

/**
 * Ширина самой большой колонки в таблице
 */
const MAIN_COLUMN_WIDTH = 324;

export const useCreateDictionaryTable = (
  store: DictionarySettingsStore
): ColumnsType<DictionarySettingsValueModel> => {
  const { t } = useTranslation();

  return React.useMemo(
    () => [
      {
        title: t('dictionary.order'),
        render: (_, entity, index) => {
          return <OrderSelect index={index} entity={entity} />;
        },
      },
      {
        dataIndex: 'label',
        title: t('dictionary.label'),
        width: MAIN_COLUMN_WIDTH,
        render: (_, entity) => {
          return <Label entity={entity} />;
        },
      },
      {
        title: t('dictionary.byDefault'),
        render: (_, entity) => {
          return <ByDefaultRadioButton entity={entity} />;
        },
      },
      {
        dataIndex: 'delete',
        render: (_, entity) => {
          return <DeleteRowButton entity={entity} />;
        },
      },
    ],
    // eslint-disable-next-line
    [store.values, t]
  );
};
